import { render } from "./CGV.vue?vue&type=template&id=e050db28&scoped=true"
const script = {}

import "./CGV.vue?vue&type=style&index=0&id=e050db28&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e050db28"]])

export default __exports__